import { ShieldCheck, TrendingUp, Award, HeartHandshake } from "lucide-react";
import { Reveal, RevealStagger, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";

const POINTS = [
  { icon: Award, title: "Premium Development", desc: "Architect-controlled facades and uncompromising build quality across every project." },
  { icon: HeartHandshake, title: "Customer Satisfaction", desc: "We aim for the highest customer satisfaction — for end users and investors alike." },
  { icon: TrendingUp, title: "High ROI", desc: "First-mover positioning in Kharkhoda designed for strong, lasting investor returns." },
  { icon: ShieldCheck, title: "Trusted Developer", desc: "Delivered in partnership with Pinnacle Architects Pvt. Ltd. for engineering excellence." },
];

export const WhyBuildaxis = () => (
  <section id="why-buildaxis" className="cp-section cp-section--cream" data-testid="why-buildaxis-section">
    <div className="cp-container cp-buildaxis-grid">
      <Reveal>
        <span className="cp-eyebrow">Why Buildaxis</span>
        <h2 className="cp-h2">Building With Intent, Investing With Confidence</h2>
        <p className="cp-section-desc">
          Buildaxis Developers is the promoter behind Central Plaza, working alongside Pinnacle
          Architects Pvt. Ltd. We are aiming for the highest customer satisfaction and high ROI
          for our investors — bringing Kharkhoda its first premium, developer-controlled SCO
          address.
        </p>
      </Reveal>
      <RevealStagger className="cp-buildaxis-points" stagger={0.08}>
        {POINTS.map((p) => (
          <motion.div key={p.title} variants={revealItem} className="cp-buildaxis-point" data-testid={`why-buildaxis-${p.title.toLowerCase().replace(/\s/g, "-")}`}>
            <p.icon size={20} strokeWidth={1.6} />
            <div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
          </motion.div>
        ))}
      </RevealStagger>
    </div>
  </section>
);
